import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';

import {UserService} from '../../services/user.service';

import {Observable} from 'rxjs';
import {OrganizationUser} from '../../../afb-api/models/organization-user';
import {VerticalAlignment} from '../../../vision/dropdown/enums/dropdown.enum';

@Component({
  selector: 'awair-access-mgmt-dialog',
  templateUrl: './access-mgmt-dialog.component.html',
  styleUrls: ['./access-mgmt-dialog.component.scss']
})

export class AccessMgmtDialogComponent implements OnInit {
  @Output() save: EventEmitter<{
    inviteeList: string[],
    removeList: OrganizationUser[],
    removePendingAdminList: OrganizationUser[],
    removePendingMemberList: OrganizationUser[],
    removeAllGroupList: OrganizationUser[]
  }> = new EventEmitter();
  @Output() reinviteAdmin: EventEmitter<OrganizationUser> = new EventEmitter<OrganizationUser>();
  @Output() reinviteMember: EventEmitter<OrganizationUser> = new EventEmitter<OrganizationUser>();
  // Organization user
  inviteeList: string[] = [];

  removeList: OrganizationUser[] = [];
  removePendingAdminList: OrganizationUser[] = [];
  removePendingMemberList: OrganizationUser[] = [];
  removeAllGroupList: OrganizationUser[] = [];

  addCtr: number = 0;
  removeCtr: number = 0;
  unassignedCtr: number = 0;
  isLoading: boolean = false;
  isInfoPopup: boolean = false;
  selectedTabIndex: number;

  orgUserList$: Observable<OrganizationUser[]>;
  activeOrgMemberList$: Observable<OrganizationUser[]>;
  pendingOrgMemberList$: Observable<OrganizationUser[]>;
  activeOrgAdminList$: Observable<OrganizationUser[]>;
  pendingOrgAdminList$: Observable<OrganizationUser[]>;
  orgOwner$: Observable<OrganizationUser>;

  activeOrgMemberWithStatusList: OrgMemberWithStatus[];
  pendingOrgMemberWithStatusList: OrgUserWithRemovedStatus[];
  activeOrgAdminWithStatusList: OrgUserWithRemovedStatus[];
  pendingOrgAdminWithStatusList: OrgUserWithRemovedStatus[];

  VerticalAlignment = VerticalAlignment;

  constructor(private userService: UserService,
              private dialog: MatDialog,
              private myDialogRef: MatDialogRef<AccessMgmtDialogComponent>) {
  }

  ngOnInit() {
    // Init organization users
    this.orgUserList$ = this.userService.getOrgUserList();
    this.activeOrgMemberList$ = this.userService.getActiveOrgMemberList();
    this.activeOrgMemberList$.subscribe((activeOrgMemberList: OrganizationUser[]) => {
      this.activeOrgMemberWithStatusList = activeOrgMemberList.reduce(
        (accumulator: OrgMemberWithStatus[], activeOrgMember: OrganizationUser) => {
          return [...accumulator, {...activeOrgMember, unassigned: false, removed: false}];
        }, []);
    });
    this.pendingOrgMemberList$ = this.userService.getPendingOrgMemberList();
    this.pendingOrgMemberList$.subscribe((pendingOrgMemberList: OrganizationUser[]) => {
      this.pendingOrgMemberWithStatusList = pendingOrgMemberList.reduce(
        (accumulator: OrgMemberWithStatus[], pendingOrgMember: OrganizationUser) => {
          return [...accumulator, {...pendingOrgMember, removed: false}];
        }, []);
    });

    this.activeOrgAdminList$ = this.userService.getActiveOrgAdminList();
    this.activeOrgAdminList$.subscribe((activeOrgAdminList: OrganizationUser[]) => {
      this.activeOrgAdminWithStatusList = activeOrgAdminList.reduce(
        (accumulator: OrgUserWithRemovedStatus[], activeOrgAdmin: OrganizationUser) => {
          return [...accumulator, {...activeOrgAdmin, removed: false}];
        }, []);
    });
    this.pendingOrgAdminList$ = this.userService.getPendingOrgAdminList();
    this.pendingOrgAdminList$.subscribe((pendingOrgAdminList: OrganizationUser[]) => {
      this.pendingOrgAdminWithStatusList = pendingOrgAdminList.reduce(
        (accumulator: OrgUserWithRemovedStatus[], pendingOrgAdmin: OrganizationUser) => {
          return [...accumulator, {...pendingOrgAdmin, removed: false}];
        }, []);
    });
    this.orgOwner$ = this.userService.getOrgOwner();
  }

  tabSelected(selectedTabIndex: number) {
    this.selectedTabIndex = selectedTabIndex;
  }

  addInvitee(email: string): void {
    // Not mutating original object to reflect input
    this.inviteeList = [...this.inviteeList, email];
    this.addCtr = this.inviteeList.length;
    this.selectedTabIndex = 2;
  }

  removeInvitee(email: string): void {
    const index = this.inviteeList.findIndex((invitee: string) => invitee === email);
    if (index !== -1) {
      this.inviteeList.splice(index, 1);
    }
    this.addCtr = this.inviteeList.length;
  }

  removeFromOrg(orgUser: OrgUserWithRemovedStatus | OrgMemberWithStatus): void {
    orgUser.removed = true;

    const orgUserCopy = {...orgUser};
    delete orgUserCopy.removed;
    this.removeList = [...this.removeList, <OrganizationUser>orgUserCopy];
    this.updateRemoveCounter();
  }

  undoRemoveFromOrg(orgUser: OrgUserWithRemovedStatus | OrgMemberWithStatus): void {
    orgUser.removed = false;

    const index = this.removeList.findIndex((removeOrgUser: OrganizationUser) => removeOrgUser.userId === orgUser.userId);
    if (index !== -1) {
      this.removeList.splice(index, 1);
    }
    this.updateRemoveCounter();
  }

  removePendingAdminFromOrg(orgUser: OrgUserWithRemovedStatus | OrgMemberWithStatus): void {
    orgUser.removed = true;

    const orgUserCopy = {...orgUser};
    delete orgUserCopy.removed;
    this.removePendingAdminList = [...this.removePendingAdminList, <OrganizationUser>orgUserCopy];
    this.updateRemoveCounter();
  }

  undoRemovePendingAdminFromOrg(orgUser: OrgUserWithRemovedStatus | OrgMemberWithStatus): void {
    orgUser.removed = false;

    const index = this.removePendingAdminList.findIndex((removeOrgUser: OrganizationUser) => removeOrgUser.userId === orgUser.userId);
    if (index !== -1) {
      this.removePendingAdminList.splice(index, 1);
    }
    this.updateRemoveCounter();
  }

  removePendingMemberFromOrg(orgUser: OrgUserWithRemovedStatus): void {
    orgUser.removed = true;

    const orgUserCopy = {...orgUser};
    delete orgUserCopy.removed;
    this.removePendingMemberList = [...this.removePendingMemberList, <OrganizationUser>orgUserCopy];
    this.updateRemoveCounter();
  }

  undoRemovePendingMemberFromOrg(orgUser: OrgUserWithRemovedStatus): void {
    orgUser.removed = false;

    const index = this.removePendingMemberList.findIndex((removeOrgUser: OrganizationUser) => removeOrgUser.userId === orgUser.userId);
    if (index !== -1) {
      this.removePendingMemberList.splice(index, 1);
    }
    this.updateRemoveCounter();
  }

  removeMemberFromAllGroup(member: OrgMemberWithStatus) {
    member.unassigned = true;

    const memberCopy = {...member};
    delete memberCopy.unassigned;
    this.removeAllGroupList = [...this.removeAllGroupList, <OrganizationUser>memberCopy];
    this.unassignedCtr = this.removeAllGroupList.length;
  }

  undoRemoveMemberFromAllGroup(member: OrgMemberWithStatus) {
    member.unassigned = false;

    const memberCopy = {...member};
    const index = this.removeAllGroupList.findIndex((removeMember: OrganizationUser) => removeMember.userId === member.userId);
    if (index !== -1) {
      this.removeAllGroupList.splice(index, 1);
    }
    this.unassignedCtr = this.removeAllGroupList.length;
  }

  onReinviteAdmin(organizationUser: OrganizationUser): void {
    this.reinviteAdmin.emit(organizationUser);
  }

  onReinviteMember(organizationUser: OrganizationUser): void {
    this.reinviteMember.emit(organizationUser);
  }

  updateRemoveCounter() {
    this.removeCtr = this.removeList.length + this.removePendingAdminList.length + this.removePendingMemberList.length;
  }

  openInfoPopup(isSelected: boolean): void {
    if (isSelected) {
      this.isInfoPopup = !this.isInfoPopup;
    } else if (this.isInfoPopup) {
      this.isInfoPopup = false;
    }
  }

  onSave(): void {
    this.save.emit({
      inviteeList: this.inviteeList,
      removeList: this.removeList,
      removePendingAdminList: this.removePendingAdminList,
      removePendingMemberList: this.removePendingMemberList,
      removeAllGroupList: this.removeAllGroupList
    });
  }

  onClose(): void {
    if (this.addCtr === 0 && this.removeCtr === 0 && this.unassignedCtr === 0) {
      this.myDialogRef.close();
    } else {
      if (confirm('Changes will not be saved.\nAre you sure you want to exit?')) {
        this.myDialogRef.close();
      }
    }
  }
}

export interface OrgMemberWithStatus extends OrganizationUser {
  unassigned: boolean;
  removed: boolean;
}

export interface OrgUserWithRemovedStatus extends OrganizationUser {
  removed: boolean;
}
